// import React, { useEffect, useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import {
//   Box,
//   Typography,
//   Container,
//   TextField,
//   Button,
//   Grid,
//   Card,
//   CardContent,
//   CircularProgress,
//   Divider,
//   Chip,
//   useTheme,
//   useMediaQuery,
// } from '@mui/material';
// import { School as SchoolIcon, Sort as SortIcon } from '@mui/icons-material';
// import { motion } from 'framer-motion';
// import { useTeacherAuth } from '../auth/TeacherAuthContext';
// import AOS from 'aos';
// import 'aos/dist/aos.css';

// const TeacherAllStudents = () => {
//   const navigate = useNavigate();
//   const { state } = useLocation();
//   const { schoolId } = state || {};
//   const { teacherData } = useTeacherAuth();
//   const [learners, setLearners] = useState([]);
//   const [filteredLearners, setFilteredLearners] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [sortConfig, setSortConfig] = useState({});
//   const [schoolStreams, setSchoolStreams] = useState({});
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   useEffect(() => {
//     AOS.init({
//       duration: 800,
//       easing: 'ease-in-out',
//       once: true,
//     });
//   }, []);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         if (!schoolId) {
//           throw new Error('Missing school ID');
//         }
//         const [learnersResponse, streamsResponse] = await Promise.all([
//           axios.get('https://kidsm.vercel.app/api/schools/learners', {
//             params: { schoolId },
//           }),
//           axios.get(`https://kidsm.vercel.app/api/schools/${schoolId}/streams`),
//         ]);

//         setLearners(learnersResponse.data || []);
//         setFilteredLearners(learnersResponse.data || []);
//         setSchoolStreams(streamsResponse.data.classStreams || {});
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [schoolId]);

//   useEffect(() => {
//     if (searchQuery.trim() === '') {
//       setFilteredLearners(learners);
//     } else {
//       const filtered = learners.filter(
//         (learner) =>
//           learner.fullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
//           learner.admissionNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
//           learner.class.toLowerCase().includes(searchQuery.toLowerCase()) ||
//           (learner.stream && learner.stream.toLowerCase().includes(searchQuery.toLowerCase()))
//       );
//       setFilteredLearners(filtered);
//     }
//   }, [searchQuery, learners]);

//   const groupLearnersByClassAndStream = (learnersArray) => {
//     const grouped = {};
//     learnersArray.forEach((learner) => {
//       const { class: className, stream } = learner;
//       const hasStreams = schoolStreams[className] && schoolStreams[className].length > 0;
//       if (!grouped[className]) {
//         grouped[className] = { hasStreams, streams: {} };
//       }
//       const streamName = hasStreams ? (stream || 'No Stream') : 'No Stream';
//       if (!grouped[className].streams[streamName]) {
//         grouped[className].streams[streamName] = [];
//       }
//       grouped[className].streams[streamName].push(learner);
//     });
//     return grouped;
//   };

//   const sortLearners = (learnersInGroup, groupKey) => {
//     if (!sortConfig[groupKey]) return learnersInGroup;
//     const { key, direction } = sortConfig[groupKey];
//     return [...learnersInGroup].sort((a, b) => {
//       if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
//       if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
//       return 0;
//     });
//   };

//   const requestSort = (groupKey, key) => {
//     let direction = 'asc';
//     if (sortConfig[groupKey] && sortConfig[groupKey].key === key) {
//       direction = sortConfig[groupKey].direction === 'asc' ? 'desc' : 'asc';
//     }
//     setSortConfig({ ...sortConfig, [groupKey]: { key, direction } });
//   };

//   const learnersByClassAndStream = groupLearnersByClassAndStream(filteredLearners);

//   const cardVariants = {
//     hidden: { opacity: 0, scale: 0.9, y: 30 },
//     visible: {
//       opacity: 1,
//       scale: 1,
//       y: 0,
//       transition: { duration: 0.5, ease: 'easeOut' },
//     },
//     hover: { scale: 1.05, transition: { duration: 0.2 } },
//   };

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           height: '100vh',
//           bgcolor: '#f5f5f5',
//         }}
//       >
//         <CircularProgress color="primary" />
//         <Typography variant="h6" sx={{ mt: 2, color: '#2c3e50' }}>
//           Loading students...
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ flexGrow: 1, bgcolor: '#f8f9fa', minHeight: '100vh', pt: 8 }}>
//       <Container maxWidth="xl" sx={{ py: 4 }}>
//         <Box sx={{ mb: 4 }} data-aos="fade-down">
//           <Typography
//             variant="h4"
//             sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 2 }}
//           >
//             All Students
//           </Typography>
//           <TextField
//             fullWidth
//             variant="outlined"
//             placeholder="Search students..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             sx={{ mb: 3, bgcolor: 'white', borderRadius: '8px' }}
//             InputProps={{
//               startAdornment: (
//                 <SchoolIcon sx={{ color: '#6200ee', mr: 1 }} />
//               ),
//             }}
//           />
//         </Box>

//         {Object.entries(learnersByClassAndStream).map(([className, classData]) => (
//           <Box key={className} sx={{ mb: 4 }} data-aos="fade-up">
//             <Box
//               sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 mb: 2,
//                 bgcolor: '#f5f5f5',
//                 p: 2,
//                 borderRadius: '8px',
//               }}
//             >
//               <SchoolIcon sx={{ color: '#6200ee', mr: 1 }} />
//               <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333' }}>
//                 {className}
//               </Typography>
//             </Box>

//             {Object.entries(classData.streams).map(([streamName, learnersInStream]) => (
//               <Box key={`${className}-${streamName}`} sx={{ mb: 3 }}>
//                 {classData.hasStreams && (
//                   <Typography
//                     variant="h6"
//                     sx={{ fontWeight: '600', color: '#555', pl: 2, mb: 1 }}
//                   >
//                     Stream: {streamName}
//                   </Typography>
//                 )}
//                 <Box sx={{ display: 'flex', mb: 2, flexWrap: 'wrap', gap: 1 }}>
//                   <Button
//                     variant="contained"
//                     startIcon={<SortIcon />}
//                     onClick={() => requestSort(`${className}-${streamName}`, 'fullName')}
//                     sx={{ bgcolor: '#6200ee', mr: 1, borderRadius: '8px' }}
//                   >
//                     Sort by Name{' '}
//                     {sortConfig[`${className}-${streamName}`]?.key === 'fullName' &&
//                       (sortConfig[`${className}-${streamName}`].direction === 'asc' ? '↑' : '↓')}
//                   </Button>
//                   <Button
//                     variant="contained"
//                     startIcon={<SortIcon />}
//                     onClick={() => requestSort(`${className}-${streamName}`, 'admissionNumber')}
//                     sx={{ bgcolor: '#6200ee', borderRadius: '8px' }}
//                   >
//                     Sort by Admission{' '}
//                     {sortConfig[`${className}-${streamName}`]?.key === 'admissionNumber' &&
//                       (sortConfig[`${className}-${streamName}`].direction === 'asc' ? '↑' : '↓')}
//                   </Button>
//                 </Box>

//                 <Grid container spacing={2}>
//                   {sortLearners(learnersInStream, `${className}-${streamName}`).map((learner) => (
//                     <Grid item xs={12} sm={6} md={4} key={learner._id}>
//                       <motion.div
//                         variants={cardVariants}
//                         initial="hidden"
//                         animate="visible"
//                         whileHover="hover"
//                       >
//                         <Card
//                           sx={{
//                             p: 2,
//                             boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                             borderRadius: '10px',
//                             cursor: 'pointer',
//                             bgcolor: 'white',
//                             borderLeft: '4px solid #6200ee',
//                           }}
//                           onClick={() =>
//                             navigate('/teacher/student-details', { state: { learner } })
//                           }
//                         >
//                           <CardContent>
//                             <Typography
//                               variant="h6"
//                               sx={{ fontWeight: '600', color: '#2c3e50', mb: 1 }}
//                             >
//                               {learner.fullName}
//                             </Typography>
//                             <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
//                               Admission: {learner.admissionNumber}
//                             </Typography>
//                             <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
//                               Class: {learner.class}
//                             </Typography>
//                             {learner.stream && (
//                               <Typography variant="body2" sx={{ color: '#666' }}>
//                                 Stream: {learner.stream}
//                               </Typography>
//                             )}
//                           </CardContent>
//                         </Card>
//                       </motion.div>
//                     </Grid>
//                   ))}
//                 </Grid>
//               </Box>
//             ))}
//           </Box>
//         ))}
//       </Container>
//     </Box>
//   );
// };

// export default TeacherAllStudents;


import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import {
  Box,
  Typography,
  Container,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Chip,
  useTheme,
  useMediaQuery,
  Alert,
} from '@mui/material';
import { School as SchoolIcon, Sort as SortIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { useTeacherAuth } from '../auth/TeacherAuthContext';
import AOS from 'aos';
import 'aos/dist/aos.css';

const TeacherAllStudents = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { teacherData } = useTeacherAuth();
  const schoolId = state?.schoolId || teacherData?.schoolId;
  const [learners, setLearners] = useState([]);
  const [filteredLearners, setFilteredLearners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortConfig, setSortConfig] = useState({});
  const [schoolStreams, setSchoolStreams] = useState({});
  const [error, setError] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!schoolId) {
          throw new Error('Missing school ID. Please log in again.');
        }
        setLoading(true);
        setError(null);
        const [learnersResponse, streamsResponse] = await Promise.all([
          axios.get('https://kidsm.vercel.app/api/schools/learners', {
            params: { schoolId },
          }),
          axios.get(`https://kidsm.vercel.app/api/schools/${schoolId}/streams`),
        ]);

        setLearners(learnersResponse.data || []);
        setFilteredLearners(learnersResponse.data || []);
        setSchoolStreams(streamsResponse.data.classStreams || {});
      } catch (error) {
        console.error('Error fetching data:', error);
        setError(error.message || 'Failed to load students');
        setLearners([]);
        setFilteredLearners([]);
        setSchoolStreams({});
      } finally {
        setLoading(false);
      }
    };

    if (schoolId) {
      fetchData();
    } else {
      setError('Missing school ID. Please log in again.');
      setLoading(false);
    }
  }, [schoolId]);

  useEffect(() => {
    if (searchQuery.trim() === '') {
      setFilteredLearners(learners);
    } else {
      const filtered = learners.filter(
        (learner) =>
          learner.fullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          learner.admissionNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
          learner.class.toLowerCase().includes(searchQuery.toLowerCase()) ||
          (learner.stream && learner.stream.toLowerCase().includes(searchQuery.toLowerCase()))
      );
      setFilteredLearners(filtered);
    }
  }, [searchQuery, learners]);

  const groupLearnersByClassAndStream = (learnersArray) => {
    const grouped = {};
    learnersArray.forEach((learner) => {
      const { class: className, stream } = learner;
      const hasStreams = schoolStreams[className] && schoolStreams[className].length > 0;
      if (!grouped[className]) {
        grouped[className] = { hasStreams, streams: {} };
      }
      const streamName = hasStreams ? (stream || 'No Stream') : 'No Stream';
      if (!grouped[className].streams[streamName]) {
        grouped[className].streams[streamName] = [];
      }
      grouped[className].streams[streamName].push(learner);
    });
    return grouped;
  };

  const sortLearners = (learnersInGroup, groupKey) => {
    if (!sortConfig[groupKey]) return learnersInGroup;
    const { key, direction } = sortConfig[groupKey];
    return [...learnersInGroup].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const requestSort = (groupKey, key) => {
    let direction = 'asc';
    if (sortConfig[groupKey] && sortConfig[groupKey].key === key) {
      direction = sortConfig[groupKey].direction === 'asc' ? 'desc' : 'asc';
    }
    setSortConfig({ ...sortConfig, [groupKey]: { key, direction } });
  };

  const learnersByClassAndStream = groupLearnersByClassAndStream(filteredLearners);

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9, y: 30 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: { duration: 0.5, ease: 'easeOut' },
    },
    hover: { scale: 1.05, transition: { duration: 0.2 } },
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          bgcolor: '#f5f5f5',
        }}
      >
        <CircularProgress color="primary" />
        <Typography variant="h6" sx={{ mt: 2, color: '#2c3e50' }}>
          Loading students...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          bgcolor: '#f5f5f5',
          p: 3,
          textAlign: 'center',
        }}
      >
        <Alert severity="error">{error}</Alert>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/teacher/login')}
          sx={{ mt: 2 }}
        >
          Go to Login
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ flexGrow: 1, bgcolor: '#f8f9fa', minHeight: '100vh', pt: 8 }}>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Box sx={{ mb: 4 }} data-aos="fade-down">
          <Typography
            variant="h4"
            sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 2 }}
          >
            All Students
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search students..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{ mb: 3, bgcolor: 'white', borderRadius: '8px' }}
            InputProps={{
              startAdornment: (
                <SchoolIcon sx={{ color: '#6200ee', mr: 1 }} />
              ),
            }}
          />
        </Box>

        {Object.entries(learnersByClassAndStream).map(([className, classData]) => (
          <Box key={className} sx={{ mb: 4 }} data-aos="fade-up">
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 2,
                bgcolor: '#f5f5f5',
                p: 2,
                borderRadius: '8px',
              }}
            >
              <SchoolIcon sx={{ color: '#6200ee', mr: 1 }} />
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333' }}>
                {className}
              </Typography>
            </Box>

            {Object.entries(classData.streams).map(([streamName, learnersInStream]) => (
              <Box key={`${className}-${streamName}`} sx={{ mb: 3 }}>
                {classData.hasStreams && (
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: '600', color: '#555', pl: 2, mb: 1 }}
                  >
                    Stream: {streamName}
                  </Typography>
                )}
                <Box sx={{ display: 'flex', mb: 2, flexWrap: 'wrap', gap: 1 }}>
                  <Button
                    variant="contained"
                    startIcon={<SortIcon />}
                    onClick={() => requestSort(`${className}-${streamName}`, 'fullName')}
                    sx={{ bgcolor: '#6200ee', mr: 1, borderRadius: '8px' }}
                  >
                    Sort by Name{' '}
                    {sortConfig[`${className}-${streamName}`]?.key === 'fullName' &&
                      (sortConfig[`${className}-${streamName}`].direction === 'asc' ? '↑' : '↓')}
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<SortIcon />}
                    onClick={() => requestSort(`${className}-${streamName}`, 'admissionNumber')}
                    sx={{ bgcolor: '#6200ee', borderRadius: '8px' }}
                  >
                    Sort by Admission{' '}
                    {sortConfig[`${className}-${streamName}`]?.key === 'admissionNumber' &&
                      (sortConfig[`${className}-${streamName}`].direction === 'asc' ? '↑' : '↓')}
                  </Button>
                </Box>

                <Grid container spacing={2}>
                  {sortLearners(learnersInStream, `${className}-${streamName}`).map((learner) => (
                    <Grid item xs={12} sm={6} md={4} key={learner._id}>
                      <motion.div
                        variants={cardVariants}
                        initial="hidden"
                        animate="visible"
                        whileHover="hover"
                      >
                        <Card
                          sx={{
                            p: 2,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            borderRadius: '10px',
                            cursor: 'pointer',
                            bgcolor: 'white',
                            borderLeft: '4px solid #6200ee',
                          }}
                          onClick={() =>
                            navigate('/teacher/student-details', { state: { learner } })
                          }
                        >
                          <CardContent>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: '600', color: '#2c3e50', mb: 1 }}
                            >
                              {learner.fullName}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                              Admission: {learner.admissionNumber}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                              Class: {learner.class}
                            </Typography>
                            {learner.stream && (
                              <Typography variant="body2" sx={{ color: '#666' }}>
                                Stream: {learner.stream}
                              </Typography>
                            )}
                          </CardContent>
                        </Card>
                      </motion.div>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            ))}
          </Box>
        ))}
      </Container>
    </Box>
  );
};

export default TeacherAllStudents;